import type React from 'react';

import { createPlacementComponent } from '@post-office/placement-common/utils/create-placement-component';

import { useInitialData } from '@post-office/placement-contexts/hooks';

import { MessageRenderer } from '../__generated__/client/render';

import { PLACEMENT_ID } from '../__generated__/common';

import { withJiraUpsellBannerIntlProvider } from '../__generated__/intl-provider';

import { type JiraUpsellBannerInitialData } from '../api/types';

import { type Placement as JiraUpsellBannerPlacement } from '../contracts/Placement';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const JiraUpsellBannerPlacementComponent: React.ComponentType<any> =
	withJiraUpsellBannerIntlProvider(
		createPlacementComponent<JiraUpsellBannerPlacement>(
			PLACEMENT_ID,
			({ initialData, tenantId, onCtaClick, onDismiss }) => {
				const initialDataState = useInitialData<JiraUpsellBannerInitialData>(initialData);

				if (initialDataState.isLoading) {
					return null;
				}

				return (
					<p data-testId="jira-upsell-message">
						<MessageRenderer
							tenantId={tenantId}
							// TODO: augment these on* props in a later PR
							onCtaClick={onCtaClick}
							onDismiss={onDismiss}
						/>
					</p>
				);
			},
			{
				choreographer: {
					isDefaultEnabled: false,
				},
			},
		),
	);

export default JiraUpsellBannerPlacementComponent;
